import React from "react";
const Spinner = ({ size = 1 }) => {
    return React.createElement("div", { className: "spinner", style: { fontSize: `${size}em` } });
};
export default Spinner;
